import React, {
    useEffect,
    useRef,
} from 'react';
import PropTypes from 'prop-types';
import Velocity from 'velocity-animate';

import { usePrevious } from 'app/utils/hooks';

import Checkbox, { TYPE_RADIO } from 'app/components/Form/Checkbox2';

import './period-list.scss';
import { analyticService } from 'global/services';
import { citiesLocales as cities } from 'app/const/location';

const ANIMATION_OPTIONS = {
    duration: 400,
    easing: 'ease-in-out',
};

function animateExpand(el) {
    Velocity(
        el,
        'slideDown',
        ANIMATION_OPTIONS,
    );
}

function animateCollapse(el, options = {}) {
    Velocity(
        el,
        'slideUp',
        {
            ...ANIMATION_OPTIONS,
            ...options,
        },
    );
}


function CityList(props) {
    const {
        mutateAddreessHandler,
        isExpanded,
        locationKey,
        isLocationDataLoading,
    } = props;

    const containerRef = useRef();
    const prevIsExanded = usePrevious(isExpanded);


    useEffect(() => {
        const el = containerRef.current;

        if (prevIsExanded === undefined && el) {
            animateCollapse(el, { duration: 0 });
            return;
        }

        const isExpandStateChanged = isExpanded !== prevIsExanded;

        if (!isExpandStateChanged || !el) return;

        if (isExpanded) {
            animateExpand(el);
        } else {
            animateCollapse(el);
        }
    });

    const addressString = {
        MSK: 'г Москва',
        SPB: 'г Санкт-Петербург',
        NIZ: 'г Нижний Новгород',
        KZN: 'г Казань',
        TUL: 'г Тула',
        YAR: 'г Ярославль',
        VLA: 'г Владимир',
        RYA: 'г Рязань',
        KLU: 'г Калуга',
        TVE: 'г Тверь',
        VOR: 'г Воронеж',
    };

    const CityItemsForRender = cities.map((city) => {
        const selected = city.id === locationKey;

        return {
            id: `mobile-city-select-${city.id}`,
            buttonProps: {
                onClick: () => {
                    analyticService.push({
                        eventName: 'Filter_Change_City',
                        filter_value: city.id,
                        eventAction: 'Change',
                        eventLabel: 'City',
                    });
                    mutateAddreessHandler({ address: addressString[city.id] });
                },
                name: `btn-${city.id.toLowerCase()}`,
                disabled: isLocationDataLoading || selected,
            },
            TextCmp: <>{city.value}</>,
            selected,
        };
    });

    return (
        <div styleName="period-list" ref={containerRef}>
            {CityItemsForRender.map(({
                id,
                buttonProps,
                selected,
                TextCmp,
            }) => (
                <li styleName="period-list__item" key={id}>
                    <button
                        styleName="period-list__item-button"
                        type="button"
                        {...buttonProps}
                    >
                        <Checkbox
                            type={TYPE_RADIO}
                            name="rerere"
                            id={id}
                            checked={selected}
                            onClick={() => { }}
                            onChange={(e) => e.stopPropagation()}
                        />

                        <div styleName="period-text">
                            {TextCmp}
                        </div>
                    </button>
                </li>
            ))}
        </div>
    );
}

export default CityList;
